import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useParams } from 'react-router-dom';

function ViewProduct() {
  const { id } = useParams(); // Get product ID from URL params
  const [product, setProduct] = useState(null);
  const [selectedImage, setSelectedImage] = useState('');

  useEffect(() => {
    axios.get(`https://api.vyapakprint.com/api/products/getProductById/${id}`)
      .then(response => {
        setProduct(response.data);
        setSelectedImage(response.data.images?.[0] || '');
      })
      .catch(error => {
        console.error('Error fetching product:', error);
      });
  }, [id]);

  if (!product) return <p className="text-center text-lg">Loading product details...</p>;

  return (
    <div className="container mx-auto p-6">
      <div className="bg-white shadow-lg rounded-lg flex flex-col md:flex-row overflow-hidden">
        {/* Image Gallery */}
        <div className="md:w-1/2">
          <div className="flex justify-center">
            <img
              src={selectedImage}
              alt="Main Product"
              className="h-96 w-auto object-cover rounded-t-lg"
            />
          </div>
          <div className="flex overflow-x-auto space-x-2 mt-2 px-2 pb-2">
            {product.images.map((image, index) => (
              <img
                key={index}
                src={image}
                alt={`Product Image ${index + 1}`}
                onClick={() => setSelectedImage(image)}
                className={`h-24 w-24 object-cover rounded-lg shadow-md cursor-pointer transition-transform transform hover:scale-105 ${
                  selectedImage === image ? 'ring-2 ring-orange-500' : ''
                }`}
              />
            ))}
          </div>
        </div>

        {/* Product Details */}
        <div className="md:w-1/2 px-6 mb-4 flex flex-col justify-between">
          <h2 className="text-3xl font-bold mb-4">{product.name}</h2>
          <div className="space-y-2">
            <p><strong>Product ID:</strong> {product._id}</p>
            <p><strong>Category:</strong> {product?.category?.name || "Generic"}</p>
            <p><strong>Subcategory:</strong> {product.subCategory || "N/A"}</p>
            <p><strong>Description:</strong> {product.description}</p>

            <div>
              <strong>Price Tiers:</strong>
              {product.priceTiers.map((tier, idx) => (
                <span key={idx} className="block">Quantity: {tier.quantity}, Price: ₹{tier.price}</span>
              ))}
            </div>

            <p><strong>Die Shape:</strong> {product.isDieShape ? 'Yes' : 'No'}</p>
            <p><strong>Paper Type Available:</strong> {product.isPaperType ? 'Yes' : 'No'}</p>
            {product.isPaperType && product.paperTypes.length > 0 && (
              <div>
                <strong>Paper Types:</strong>
                <ul className="list-disc ml-5">
                  {product.paperTypes.map((type, index) => (
                    <li key={index}>{type}</li>
                  ))}
                </ul>
              </div>
            )}

            <p><strong>Flap Opening Available:</strong> {product.isFlapOpening ? 'Yes' : 'No'}</p>
            {product.isFlapOpening && product.flapOpenings.length > 0 && (
              <div>
                <strong>Flap Openings:</strong>
                <ul className="list-disc ml-5">
                  {product.flapOpenings.map((type, index) => (
                    <li key={index}>{type}</li>
                  ))}
                </ul>
              </div>
            )}

            <p><strong>Window Cutting Available:</strong> {product.isWindowCutting ? 'Yes' : 'No'}</p>
            {product.isWindowCutting && product.windowCuttings.length > 0 && (
              <div>
                <strong>Window Cuttings:</strong>
                <ul className="list-disc ml-5">
                  {product.windowCuttings.map((type, index) => (
                    <li key={index}>{type}</li>
                  ))}
                </ul>
              </div>
            )}

            <p><strong>Printing Available:</strong> {product.isPrinting ? 'Yes' : 'No'}</p>
            {product.isPrinting && product.printings.length > 0 && (
              <div>
                <strong>Printings:</strong>
                <ul className="list-disc ml-5">
                  {product.printings.map((type, index) => (
                    <li key={index}>{type}</li>
                  ))}
                </ul>
              </div>
            )}

            <p><strong>Lamination Type Available:</strong> {product.isLaminationType ? 'Yes' : 'No'}</p>
            {product.isLaminationType && product.laminationTypes.length > 0 && (
              <div>
                <strong>Lamination Types:</strong>
                <ul className="list-disc ml-5">
                  {product.laminationTypes.map((type, index) => (
                    <li key={index}>{type}</li>
                  ))}
                </ul>
              </div>
            )}

            <p><strong>Minimum Quantity:</strong> {product.minQuantity}</p>
            <p><strong>Expected Delivery Time:</strong> {product.expectedDeliveryTime}</p>

            {/* Video Section */}
            {product.videoUrl && (
              <div className="mt-4">
                <strong>Product Video:</strong>
                <div className="mt-2">
                  {product.videoUrl.includes('youtube') ? (
                    <iframe
                      width="100%"
                      height="315"
                      src={product.videoUrl.replace("watch?v=", "embed/")}
                      title="Product Video"
                      frameBorder="0"
                      allowFullScreen
                    ></iframe>
                  ) : (
                    <video width="100%" height="315" controls>
                      <source src={product.videoUrl} type="video/mp4" />
                      Your browser does not support the video tag.
                    </video>
                  )}
                </div>
              </div>
            )}

            <p><strong>Date Added:</strong> {new Date(product.createdAt).toLocaleDateString()}</p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ViewProduct;
